/**
 * What the order's Apostille add-on covers: the Apostille option (with or
 * without the optional label fee) or New York (label included). Orders saved
 * before these options existed have no option and keep "Apostilled".
 */
export const getApostilleLabel = (apostilled?: any): string => {
  if (!apostilled?.option) return 'Apostilled';
  if (apostilled.option === 'NEW_YORK') return 'Apostille – New York';

  return apostilled.labelFee ? 'Apostille + Label Fee' : 'Apostille';
};
